import React from 'react';
import Button, { ButtonProps } from '@material-ui/core/Button';

interface OutlineButtonProps extends ButtonProps {}

export function OutlineButton(props: OutlineButtonProps) {
  return <Button color="primary" variant="outlined" {...props} />;
}
